import { motion } from 'framer-motion';
const inner = {
  hidden: {
    fill: 'rgba(255, 255, 255, 0)',
    rotate: 180,
  },
  visible: {
    fill: '#39ccff',
    transition: { duration: 1 },
    rotate: 0,
  },
  exit: {
    transition: { duration: 0.75 },
    rotate: 180,
  },
};
const outer = {
  hidden: {},
  visible: {
    transition: { duration: 1 },
    rotate: 180,
  },
  exit: {
    transition: { duration: 0.75 },
    rotate: 0,
  },
};

function SvgComponent({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <circle cx={256.7} cy={256} r={138.3} fill="#593810" />
      <motion.path
        variants={outer}
        initial="hidden"
        animate="visible"
        exit="exit"
        d="M400.3 311.8L494 256l-93.7-55.8c-4.7-12-10.6-22.6-17.9-33.2l21.3-59.2-58.6 21.2c-10-7.3-21.3-13.3-33.2-17.9L256 18l-55.8 93.7c-12 4.7-22.6 10.6-33.2 17.9l-58.5-21.3 21.3 58.5c-7.3 10-13.3 21.3-17.9 33.2L18 256l93.7 55.8c4.7 12 10.6 22.6 17.9 33.2l-21.3 59.2 58.5-21.3c10 7.3 21.3 13.3 33.2 17.9l56 93.2 55.8-93.7c12-4.7 22.6-10.6 33.2-17.9l59.2 21.3-21.2-58.6c7.3-10 13.3-21.3 17.3-33.3zM256 384.3c-70.5 0-128.3-57.2-128.3-128.3S185.5 127.7 256 127.7 384.3 185.5 384.3 256c0 70.5-57.8 128.3-128.3 128.3z"
        fill="#ff9c00"
      />
      <motion.path
        variants={inner}
        initial="hidden"
        animate="visible"
        exit="exit"
        d="M341.8 252.7c.7-6-4.7-12-5.3-18.6 0-3.3-1.3-6.6-2.7-10-1.3-3.3-1.3-6.6-2-9.3h-.7c4-8-7.3-17.3-12.6-23.3-6.6-6.6-10-15.3-19.9-18.6-4.7-2-9.3-4.7-14.6-6.6-4.7-2-10-3.3-14-4.7-4.7-2-8-6-13.3-5.3-5.3.7-8 4-14 2.7-12-4-20.6 2.7-29.9 9.3-4.7 3.3-9.3 6-13.3 9.3-1.3 1.3-2.7 3.3-4 5.3-1.3 2-4 3.3-5.3 6-2.7 4-6.6 6.6-10.6 9.3-2 1.3-3.3 4-6 5.3-3.3 2-4 1.3-4 5.3 0 5.3 2.7 9.3 2.7 14v8c.7 2.7 1.3 4.7 2 7.3 1.3 4.7 0 10 2 14 2.7 4 5.3 8.6 8.6 12 3.3 4 6.6 8.6 10 13.3 2 2.7 9.3 6.6 9.3 10.6 5.3 1.3 6.6 7.3 11.3 7.3 2.7-.7 5.3-.7 7.3 0 2.7.7 4.7 1.3 7.3 2 4.7 0 8-4 12.6-5.3 4.7-1.3 10 0 14.6-2 8.6-5.3 14-14.6 14.6-24.6 0-5.3-1.3-10.6-4.7-14.6-2.7-4.7-.7-10-5.3-12.6-4.7-2-10-4-16-4-5.3-2-10.6-1.3-16 .7-8.6 6 10.6 19.9.7 24.6-11.3 4.7-17.3-8-19.9-16.6-1.3-5.3-1.3-11.3 0-16.6 0-2.7.7-4.7 1.3-7.3 1.3-2 4-3.3 6-4 4-2.7 7.3-6.6 11.3-9.3s9.3-4.7 14-6c6-1.3 12-1.3 17.9-1.3 2.7 0 5.3.7 8 .7s4.7-1.3 7.3-1.3c4 0 2.7 1.3 2.7 4.7 0 2 1.3 4 2.7 6 3.3 4 6 8 9.3 12 6.6 8 5.3 20.6 4.7 30.6-.7 5.3 0 10.6 1.3 16 2 6-2.7 6-6.6 9.3-2.7 4-5.3 8-7.3 12-3.3 4-6.6 7.3-10.6 10-3.3 3.3-7.3 6-10.6 8.6-4.7 2.7-9.3 5.3-14 7.3-5.3 2-11.3 3.3-16.6 4.7-2.7.7-5.3 1.3-8 2.7-2 1.3-3.3 4-6 5.3-6.6 4-14 3.3-21.3 6.6-4 2-17.3 2.7-17.9 7.3h-.7c2 4 6 7.3 10.6 8 4.7.7 9.3 2 13.3 3.3 4.7 2 8.6 2.7 13.3 3.3 4.7 0 8.6 2.7 13.3 3.3 5.3.7 9.3-3.3 14-4 5.3-.7 10.6-.7 16-1.3 5.3-.7 10-2 15.3-3.3 4.7-2 9.3-2 14-4 4.7-2 8.6-4 12.6-6.6 4-2.7 4.7-7.3 8.6-10 4-2.7 7.3-5.3 10.6-8.6 2.7-4 4.7-8.6 5.3-13.3 2-4 4.7-8 7.3-11.3 2-4.7 4-9.3 4.7-14 2-4.7 2-9.3 2-14.6-.7-2.7-3.3-4-2-7.3 3.9-3.8 4.6-5.8 5.3-7.8z"
        fill="#39ccff"
        id="core"
      />
    </svg>
  );
}

export default SvgComponent;
